import { AfterContentChecked, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Reuniao } from '../../../../core/reuniao';

@Component({
  selector: 'participantes-reuniao',
  templateUrl: './participantes-reuniao.component.html',
  styleUrls: ['./participantes-reuniao.component.css']
})
export class ParticipantesReuniaoComponent implements OnInit, AfterContentChecked {

  @Input() reuniao: Reuniao;

  openFormCadastro = false;

  constructor(protected drc: ChangeDetectorRef) {
  }

  ngOnInit() {}

  ngAfterContentChecked(): void {
    this.drc.detectChanges();
  }

  onGetAdicionar(evento) {
    this.openFormCadastro = evento;
  }

}
